// extracted by mini-css-extract-plugin
module.exports = {"container":"sectionComponent_container__j6ar5","light":"sectionComponent_light__2bmjC","dark":"sectionComponent_dark__1gshh","secondary":"sectionComponent_secondary__nPGNx"};
    if(module.hot) {
      // 1790670292287
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  